import styled, { css } from 'styled-components';
import { Media, TextStylesMobile, TextStylesDesktop, Colors } from 'enums';

type ButtonKind = 'primary' | 'secondary' | 'custom';

export type ButtonTypeProps = {
  kind: ButtonKind;
};

export const Button = styled.button<ButtonTypeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 100%;
  color: ${Colors.gray1};
  flex-shrink: 0;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${TextStylesMobile.button};
  border-radius: 8px;
  height: 48px;

  @media ${Media.notebook} {
    ${TextStylesDesktop.button};
    border-radius: 10px;
    height: 64px;
  }

  ${({ kind, disabled }) => {
    if (!disabled && kind === 'primary') {
      return css`
        background-color: ${Colors.yellow1};

        @media ${Media.notebook} {
          &:hover {
            background-color: ${Colors.yellow3};
          }
        }

        &:active {
          background-color: ${Colors.yellow2};
        }
      `;
    }

    if (disabled && kind === 'primary') {
      return css`
        color: ${Colors.gray2};
        background-color: ${Colors.gray3};
      `;
    }

    if (!disabled && kind === 'secondary') {
      return css`
        background-color: ${Colors.gray4};

        @media ${Media.notebook} {
          &:hover {
            background-color: ${Colors.gray3};
          }
        }

        &:active {
          background-color: ${Colors.white};
        }
      `;
    }

    if (disabled && kind === 'secondary') {
      return css`
        color: ${Colors.gray2};
        background-color: ${Colors.gray4};
      `;
    }

    return undefined;
  }};
`;
